// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 2560px) {
  .aboutus_banner_link_home,
  .aboutus_banner_link_about,
  .aboutus_banner_link_arrow {
    font-size: 28px;
  }
  .aboutus_banner_heading {
    font-size: 45px;
  }
  .aboutus_banner_content {
    font-size: 33px;
  }
  .aboutus_banner_content_ta {
    font-size: 25px;
  text-align: justify;

  }
  .our_mission_right_heading {
    font-size: 32px;
  }

  .policies_description {
    font-size: 34px;
  }
  .funding_container_right {
    width: 50%;
    margin: 0px 0px 20px 30px;
    padding: 30px 70px;
    border-radius: 12px;
  }
  .funding_container {
    justify-content: space-between;
  }
  .funding_right_head {
    font-size: 28px;
  }
  .award_list_image {
    width: 410px;
  }
  .award_list_two_img {
    height: 16vh;
  }
  .our_mission_right_content {
    font-size: 27px;
  }
  .youturn_logo {
    width: 900px;
  }
  .logo_content {
    font-size: 25px;
  }
  .meet_the_team_heading {
    font-size: 50px;
  }
  .our_mission_rightmeet_the_team_right_para {
    font-size: 29px;
  }
  .team_member_image {
    height: 330px;
    width: 330px;
  }
  .medical_expert_heading {
    font-size: 48px;
  }
  .ifcn_image_desktop {
    height: 600px;
  }
  .ifcn_heading {
    font-size: 30px;
  }
  .team_member_description {
    width: 320px;
    height: 65px;
  }
  .team_member_name {
    font-size: 20px;
  }
  .team_member_position {
    font-size: 21px;
  }
  .ifcn_description {
    font-size: 33px;
  }
  .fight_fake_news_head {
    font-size: 28px;
  }
  .fight_fake_news_hash_val {
    font-size: 72px;
  }
  .fight_fake_news_hash {
    font-size: 150px;
  }
  .figh_fake_news_note {
    font-size: 22px;
  }
  .figh_fake_news_button {
    height: 55px;
    font-size: 30px;
  }
  .policies_heading {
    font-size: 48px;
    margin: 40px 0;
  }
  .policies_button {
    height: 5vh;
    font-size: 30px;
  }
  .fact_check_image {
    height: 150px;
    width: 150px;
  }
  .button_img {
    width: 35px;
    height: 35px;
  }
  .fact_check_heading_dt {
    font-size: 40px;
  }
  .fact_check_description {
    font-size: 28px;
  }
  .what_we_check_items {
    height: 300px;
    width: 300px;
  }
  .what_we_check_img {
    height: 130px;
    width: 140px;
  }
  .what_we_check_text {
    font-size: 28px;
  }
  .fact_check_image_one {
    height: 180px;
    width: 180px;
  }
  .fact_check_description_one {
    font-size: 30px;
    width: 900px;
    min-height: 172px;
    border-top-right-radius: 90px;
    border-bottom-right-radius: 90px;
    border: 2px solid #a1a1a1;
    border-left: none;
  }
  .share_circle {
    height: 600px;
    width: 600px;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    right: -350px;
  }
  .circle_share_one {
    position: relative;
    top: 60px;
    left: 225px;
    height: 45px;
  }
  .circle_share_two {
    position: relative;
    top: 102px;
    left: 92px;
    height: 45px;
  }
  .circle_share_three {
    position: relative;
    top: 170px;
    left: -10px;
    height: 45px;
  }
  .circle_share_four {
    position: relative;
    top: 205px;
    left: 65px;
    height: 45px;
  }
  .circle_share_five{
    position: relative;
    top: 290px;
    left: 65px;
    height: 50px;
  }
  .circle_share_six{
    position: relative;
    top: 350px;
    left: 125px;
    height: 45px;
  }
  .circle_share_text {
    position: relative;
    top: 180px;
    left: 30px;
    color: white;
    font-family: "lato";
    width: 150px;
  }
  .circle_share_text_heading {
    margin: 0;
    font-size: 19px;
  }
  .circle_share_text_heading_ta {
    margin: 0;
    font-size: 19px;
  }
  .circle_share_text_description {
    margin: 0;
    font-size: 23px;
    text-wrap: wrap;
    font-weight: 700;
  }
  .circle_share_text_description_ta {
    margin: 0;
    font-size: 18px;
    text-wrap: wrap;
    font-weight: 700;
  }
  .fight_fake_news_funding_hash_val {
    font-size: 72px;
  }
  .fight_fake_news_funding_hash {
    font-size: 130px;
  }
  .funding_head {
    font-size: 48px;
  }
  .funding_right_note_one {
    font-size: 35px;
  }
  .funding_right_note_two {
    font-size: 22px;
  }
  .funding_amount_button {
    height: 60px;
    font-size: 24px;
  }
  .funding_enter_amount_button {
    height: 60px;
    font-size: 28px;
  }
  .funding_donate_button {
    height: 60px;
    font-size: 28px;
  }
  .funding_button {
    font-size: 30px;
    height: 5vh;
  }
  .large_device {
    font-size: 30px;
  }
  .award_list_two_img {
    height: 30vh;
  }
  .award_list_one_description {
    font-size: 34px;
  }
  .award_list_one_content {
    font-size: 26px;
  }
  .award_list_one_link {
    font-size: 26px;
  }
  .become_a_member_heading {
    font-size: 30px;
  }
  .award_list_div {
    margin-bottom: 30px;
  }
  .team_members_profile_card {
    display: flex;
    width: 100%;
    margin-bottom: 70px;
    padding: 15px;
    flex-direction: row;
    align-items: center;
    gap: 20%;
  }
  .hide_about_page_in_web {
    display: none;
  }
  .about_us_join_use_card_container {
    display: none;
  }
  .notes_text_size{
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_2560_layout/screen_2506_aboutus.css"],"names":[],"mappings":"AAAA;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB,mBAAmB;;EAEnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 2560px) {\r\n  .aboutus_banner_link_home,\r\n  .aboutus_banner_link_about,\r\n  .aboutus_banner_link_arrow {\r\n    font-size: 28px;\r\n  }\r\n  .aboutus_banner_heading {\r\n    font-size: 45px;\r\n  }\r\n  .aboutus_banner_content {\r\n    font-size: 33px;\r\n  }\r\n  .aboutus_banner_content_ta {\r\n    font-size: 25px;\r\n  text-align: justify;\r\n\r\n  }\r\n  .our_mission_right_heading {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .policies_description {\r\n    font-size: 34px;\r\n  }\r\n  .funding_container_right {\r\n    width: 50%;\r\n    margin: 0px 0px 20px 30px;\r\n    padding: 30px 70px;\r\n    border-radius: 12px;\r\n  }\r\n  .funding_container {\r\n    justify-content: space-between;\r\n  }\r\n  .funding_right_head {\r\n    font-size: 28px;\r\n  }\r\n  .award_list_image {\r\n    width: 410px;\r\n  }\r\n  .award_list_two_img {\r\n    height: 16vh;\r\n  }\r\n  .our_mission_right_content {\r\n    font-size: 27px;\r\n  }\r\n  .youturn_logo {\r\n    width: 900px;\r\n  }\r\n  .logo_content {\r\n    font-size: 25px;\r\n  }\r\n  .meet_the_team_heading {\r\n    font-size: 50px;\r\n  }\r\n  .our_mission_rightmeet_the_team_right_para {\r\n    font-size: 29px;\r\n  }\r\n  .team_member_image {\r\n    height: 330px;\r\n    width: 330px;\r\n  }\r\n  .medical_expert_heading {\r\n    font-size: 48px;\r\n  }\r\n  .ifcn_image_desktop {\r\n    height: 600px;\r\n  }\r\n  .ifcn_heading {\r\n    font-size: 30px;\r\n  }\r\n  .team_member_description {\r\n    width: 320px;\r\n    height: 65px;\r\n  }\r\n  .team_member_name {\r\n    font-size: 20px;\r\n  }\r\n  .team_member_position {\r\n    font-size: 21px;\r\n  }\r\n  .ifcn_description {\r\n    font-size: 33px;\r\n  }\r\n  .fight_fake_news_head {\r\n    font-size: 28px;\r\n  }\r\n  .fight_fake_news_hash_val {\r\n    font-size: 72px;\r\n  }\r\n  .fight_fake_news_hash {\r\n    font-size: 150px;\r\n  }\r\n  .figh_fake_news_note {\r\n    font-size: 22px;\r\n  }\r\n  .figh_fake_news_button {\r\n    height: 55px;\r\n    font-size: 30px;\r\n  }\r\n  .policies_heading {\r\n    font-size: 48px;\r\n    margin: 40px 0;\r\n  }\r\n  .policies_button {\r\n    height: 5vh;\r\n    font-size: 30px;\r\n  }\r\n  .fact_check_image {\r\n    height: 150px;\r\n    width: 150px;\r\n  }\r\n  .button_img {\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n  .fact_check_heading_dt {\r\n    font-size: 40px;\r\n  }\r\n  .fact_check_description {\r\n    font-size: 28px;\r\n  }\r\n  .what_we_check_items {\r\n    height: 300px;\r\n    width: 300px;\r\n  }\r\n  .what_we_check_img {\r\n    height: 130px;\r\n    width: 140px;\r\n  }\r\n  .what_we_check_text {\r\n    font-size: 28px;\r\n  }\r\n  .fact_check_image_one {\r\n    height: 180px;\r\n    width: 180px;\r\n  }\r\n  .fact_check_description_one {\r\n    font-size: 30px;\r\n    width: 900px;\r\n    min-height: 172px;\r\n    border-top-right-radius: 90px;\r\n    border-bottom-right-radius: 90px;\r\n    border: 2px solid #a1a1a1;\r\n    border-left: none;\r\n  }\r\n  .share_circle {\r\n    height: 600px;\r\n    width: 600px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -350px;\r\n  }\r\n  .circle_share_one {\r\n    position: relative;\r\n    top: 60px;\r\n    left: 225px;\r\n    height: 45px;\r\n  }\r\n  .circle_share_two {\r\n    position: relative;\r\n    top: 102px;\r\n    left: 92px;\r\n    height: 45px;\r\n  }\r\n  .circle_share_three {\r\n    position: relative;\r\n    top: 170px;\r\n    left: -10px;\r\n    height: 45px;\r\n  }\r\n  .circle_share_four {\r\n    position: relative;\r\n    top: 205px;\r\n    left: 65px;\r\n    height: 45px;\r\n  }\r\n  .circle_share_five{\r\n    position: relative;\r\n    top: 290px;\r\n    left: 65px;\r\n    height: 50px;\r\n  }\r\n  .circle_share_six{\r\n    position: relative;\r\n    top: 350px;\r\n    left: 125px;\r\n    height: 45px;\r\n  }\r\n  .circle_share_text {\r\n    position: relative;\r\n    top: 180px;\r\n    left: 30px;\r\n    color: white;\r\n    font-family: \"lato\";\r\n    width: 150px;\r\n  }\r\n  .circle_share_text_heading {\r\n    margin: 0;\r\n    font-size: 19px;\r\n  }\r\n  .circle_share_text_heading_ta {\r\n    margin: 0;\r\n    font-size: 19px;\r\n  }\r\n  .circle_share_text_description {\r\n    margin: 0;\r\n    font-size: 23px;\r\n    text-wrap: wrap;\r\n    font-weight: 700;\r\n  }\r\n  .circle_share_text_description_ta {\r\n    margin: 0;\r\n    font-size: 18px;\r\n    text-wrap: wrap;\r\n    font-weight: 700;\r\n  }\r\n  .fight_fake_news_funding_hash_val {\r\n    font-size: 72px;\r\n  }\r\n  .fight_fake_news_funding_hash {\r\n    font-size: 130px;\r\n  }\r\n  .funding_head {\r\n    font-size: 48px;\r\n  }\r\n  .funding_right_note_one {\r\n    font-size: 35px;\r\n  }\r\n  .funding_right_note_two {\r\n    font-size: 22px;\r\n  }\r\n  .funding_amount_button {\r\n    height: 60px;\r\n    font-size: 24px;\r\n  }\r\n  .funding_enter_amount_button {\r\n    height: 60px;\r\n    font-size: 28px;\r\n  }\r\n  .funding_donate_button {\r\n    height: 60px;\r\n    font-size: 28px;\r\n  }\r\n  .funding_button {\r\n    font-size: 30px;\r\n    height: 5vh;\r\n  }\r\n  .large_device {\r\n    font-size: 30px;\r\n  }\r\n  .award_list_two_img {\r\n    height: 30vh;\r\n  }\r\n  .award_list_one_description {\r\n    font-size: 34px;\r\n  }\r\n  .award_list_one_content {\r\n    font-size: 26px;\r\n  }\r\n  .award_list_one_link {\r\n    font-size: 26px;\r\n  }\r\n  .become_a_member_heading {\r\n    font-size: 30px;\r\n  }\r\n  .award_list_div {\r\n    margin-bottom: 30px;\r\n  }\r\n  .team_members_profile_card {\r\n    display: flex;\r\n    width: 100%;\r\n    margin-bottom: 70px;\r\n    padding: 15px;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 20%;\r\n  }\r\n  .hide_about_page_in_web {\r\n    display: none;\r\n  }\r\n  .about_us_join_use_card_container {\r\n    display: none;\r\n  }\r\n  .notes_text_size{\r\n    font-size: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
